import { TerminalSource } from 'src/components/dispatch/vehicleRowExpand/buildExpandedRowVM';
import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

export type DeliveryTerminals = { departure?: TerminalSource; arrival?: TerminalSource };

/** 名前が空の operation は行に出しても地点が読めない。車庫での代用に任せる */
function toTerminal(
  operation: { name?: string; address?: string; departure_at?: string; arrival_at?: string } | undefined,
  timeKey: 'departure_at' | 'arrival_at',
): TerminalSource | undefined {
  const name = operation?.name?.trim();
  if (!operation || !name) return undefined;
  return { name, address: operation.address, at: operation[timeKey] };
}

/**
 * 展開行の出発・帰着に出す地点と時刻。
 *
 * 出庫は departure_operation.departure_at、帰庫は arrival_operation.arrival_at。
 * 車庫名と勤務開始時刻で代用していたため、実際の出庫が 06:30 でも 03:00 と出ていた
 * （実測 /map/2026-07-03 の delivery 53835）。
 */
export function buildDeliveryTerminals(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): Map<number, DeliveryTerminals> {
  const map = new Map<number, DeliveryTerminals>();
  for (const d of deliveries) {
    const departure = toTerminal(d.departureOperation, 'departure_at');
    const arrival = toTerminal(d.arrivalOperation, 'arrival_at');
    if (!departure && !arrival) continue;
    map.set(d.id, { departure, arrival });
  }
  return map;
}
